import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ghost-rect',
  templateUrl: './ghost-rect.component.html',
  styleUrls: ['./ghost-rect.component.scss']
})
export class GhostRectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
